import React from "react";
import "../driver_offers/Driver_Offers.css";

const Customer_Offers = () => {
  return (
    <section className="Driver_Offers Customer_Offers">
      <div className="container">
        <div className="main_div">
          <div className="img_holder">
            <img src="/assets/images/offers/customer.jpeg" className="offerimg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customer_Offers;
